import { gql } from '@apollo/client';

export const ALL_USER_ASSOCIATED_ORGANISATIONS = gql`
  query AllUserAssociatedOrganisations($input: UserAssociatedOrganisationsInput) {
    userAssociatedOrganisations: allUserAssociatedOrganisations(input: $input) {
      id
      isFunder
      isInstitution
      isServiceProvider
      funder {
        id
        name
      }
      serviceProvider {
        id
        name
      }
      institution {
        id
        name
        type {
          id
          name
        }
      }
    }
  }
`;
